import * as Yup from 'yup';

export const registerSchema = Yup.object({
    email: Yup.string()
        .email('Podaj prawidłowy adres email')
        .required('Email jest wymagany')
        .default(""),

    password: Yup.string()
        .required('Hasło jest wymagane')
        .min(8, 'Hasło musi mieć co najmniej 8 znaków')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
            'Hasło musi zawierać co najmniej jedną małą literę, jedną wielką literę i jedną cyfrę'
        )
        .default(""),

    confirmPassword: Yup.string()
        .required('Potwierdzenie hasła jest wymagane')
        .oneOf([Yup.ref('password')], 'Hasła muszą być identyczne')
        .default(""),
});

export type RegisterSchemaType = Yup.InferType<typeof registerSchema>;
